module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-007.525d8f6c.jpg";